// web/src/api/auth/AuthAPI.ts
import { AxiosInstance } from 'axios';

import SSOService from './SSOService';

export default class AuthAPI {
  client: AxiosInstance;
  sso: SSOService;

  constructor(client: AxiosInstance) {
    this.client = client;
    this.sso = new SSOService(client);
  }

  login({ userName, password }: { userName: string; password: string }) {
    return this.client.post('/authentication/login', {
      userName,
      password,
    });
  }

  logout() {
    return this.client.get('/authentication/logout');
  }

  verifySession() {
    return this.client.get('/authentication/session-status');
  }
}
